import React, { useState, useEffect } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { IPageHeaderProps } from "../../types/IPageHeader";
import LabelText from "../../ui/LabelText";
import { ForawrdBackwardButton, LogoHeader, PageHeaderContent, PageTitle } from "../../styled-components/PageHeaderStyles";
import SecondaryButton from "../../ui/SecondaryButton";
import { PlayerAvatar } from "../../styled-components/PlayerCard.Styles";
import { usePlayerSearch } from "../../contexts/SearchPlayersContext";
import { useNavigate } from "react-router-dom";

const PageHeader: React.FC<IPageHeaderProps> = ({
  title,
  isSimulate,
  isBookmark,
  isShare,
  logInTeam,
  username,
  pageName,
  isCompare,
  clubBookmark,
  clubShare,
  clearPlayerList,
  clearClubList,
  onClearPlayerListClick,
  onClearClubListClick,
  img,
  name,
  playerName,
  onClearAllFields,
  clearAllFields,
  playerResultList,
  clubResultList,
  pageTitle,
  isAddtoSortlis,
  isPlayerInShortlist,
  playerIds,
  handleAddPlayer,
  from,
  activeTab
}) => {
  const navigate = useNavigate();
  const { isButtonDisabled } = usePlayerSearch();
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      // Adjust the scrollY value based on when you want the header to become sticky
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <PageHeaderContent className={`page-header ${isSticky ? "sticky" : ""}`} activeTab={activeTab} style={{zIndex: 999}}>
        <div className="page-header-buttons">
          {!logInTeam && !username && (
            <>
              <ForawrdBackwardButton onClick={() => window.history.back()}>
                <KeyboardArrowLeftIcon fontSize="large" className="cta-btn-icons" />
              </ForawrdBackwardButton>
              <ForawrdBackwardButton onClick={() => window.history.forward()}>
                <KeyboardArrowRightIcon fontSize="large" className="cta-btn-icons" />
              </ForawrdBackwardButton>
            </>
          )}
          {logInTeam && username && (
            <LogoHeader>
              <img src={logInTeam} alt="Icon" className="team-logo" />
              <span className="user-text">WELCOME {username}</span>
            </LogoHeader>
          )}
          {isSticky && (playerName || name) && (
            <div className="header-info">
              {playerName ? (
                <PlayerAvatar className="table-avatar" backgroundImage={img} />
              ) : (
                img && <img src={img} alt="club-image" height={48} width={48} />
              )}

              {playerName && <LabelText className="player-detail-given-name">{playerName}</LabelText>}
              {name && <LabelText className="player-detail-given-name">{name}</LabelText>}
            </div>
          )}

          {playerResultList && isSticky && (
            <div className="header-info">
              <LabelText className="player-family-name">Players</LabelText>
            </div>
          )}

          {clubResultList && isSticky && <LabelText className="player-family-name">Clubs</LabelText>}

          {pageTitle && (
            <div className="page-title">
              <LabelText className="player-family-name">{pageTitle}</LabelText>
            </div>
          )}
        </div>
        <div className="cta-buttons">
          {isCompare && <SecondaryButton label="Compare" iconType="compare" />}
          {isSimulate && <SecondaryButton label="Simulate" iconType="Simulate" />}
          {isBookmark && (
            <SecondaryButton
              // label="Simulate"
              iconType="Bookmark"
            />
          )}
          {pageName === 'player-detail' && (
              <LabelText>
                <a 
                  style={{ textDecoration: 'underline', color: '#545de0ff' }}
                  href={`/player-widget?playerId=${playerIds!}`}
                  target="_blank" // Opens in new tab
                  rel="noopener noreferrer" // Security best practice
                >
                  Player-Card
                </a>
              </LabelText>
            )}
          {isAddtoSortlis && (
            <SecondaryButton
              label={isPlayerInShortlist ? "Added to shortlist" : "Add to shortlist"}
              iconType="bookmark"
              onClick={() => handleAddPlayer && handleAddPlayer(playerIds!)}
              isSelected={isPlayerInShortlist}
            />
          )}
          {isShare && (
            <SecondaryButton
              // label="Simulate"
              iconType="Share"
            />
          )}
          {clubBookmark && <SecondaryButton label="Bookmark search criteria" iconType="Bookmark" />}
          {clubShare && <SecondaryButton label="Share search results" iconType="Share" />}
          {clearPlayerList && <SecondaryButton label="Start new search" iconType="refresh" onClick={onClearPlayerListClick} />}
          {clearClubList && <SecondaryButton label="Start new search" iconType="refresh" onClick={onClearClubListClick} />}
          {clearAllFields && (
            <SecondaryButton label="Clear all fields" iconType="refresh" onClick={onClearAllFields} disabled={from === "clubsearch" ? false : !isButtonDisabled} />
          )}
        </div>
      </PageHeaderContent>

      {title && (
        <PageTitle>
          <LabelText className="page-title-text page-padding">{title}</LabelText>
        </PageTitle>
      )}
    </>
  );
};

export default PageHeader;
